import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import './ModernLanding.css';
import Footer from '../Style/Footer';
import androidLogoImage from '../../images/getongp.svg';
import iosLogoImage from '../../images/getonas.svg';
import phoneStock from '../../images/phone_stock.png';
import appscreen from '../../images/iframe1.png';
import appscreen1 from '../../images/iframe2.png';
import appscreen2 from '../../images/iframe3.png';
import appscreen3 from '../../images/iframe4.png';
import appscreen4 from '../../images/iframe5.png';
import appscreen5 from '../../images/iframe6.png';
import appscreen6 from '../../images/iframe7.png';
import appscreen7 from '../../images/iframe8.png';

const screenshots = [
  appscreen,
  appscreen1,
  appscreen2,
  appscreen3,
  appscreen4,
  appscreen5,
  appscreen6,
  appscreen7,
];

const ModernLanding = ({
  totalNumber,
  examNumber,
  themesNumber,
  isYandexLoading,
  yandexPasswordMode,
  yandexEmail,
  yandexPassword,
  yandexPasswordConfirmation,
  isYandexPasswordLoading,
  email,
  password,
  isRegistering,
  isEmailAuthLoading,
  authError,
  authNotice,
  onYandexSignIn,
  onYandexPasswordChange,
  onYandexPasswordConfirmationChange,
  onYandexPasswordSubmit,
  onYandexPasswordReset,
  onCancelYandexPassword,
  onEmailChange,
  onPasswordChange,
  onEmailAuth,
  onPasswordReset,
  onToggleEmailAuthMode,
}) => {
  const germanSiteUrl =
    process.env.REACT_APP_GERMAN_SITE_URL || 'https://zielstudienkolleg.de/';

  return (
    <div className="auth-landing">
      <main className="auth-shell">
        <section className="auth-hero">
          <div className="auth-hero__copy">
            <span className="auth-eyebrow">Подготовка к Studienkolleg</span>
            <h1>Твоя цель — Studienkolleg?</h1>
            <p>
              ZielStk поможет выбрать подходящий Studienkolleg и уверенно подготовиться
              к вступительным экзаменам.
            </p>

            <div className="auth-store-links" aria-label="Скачать приложение">
              <a
                href="https://play.google.com/store/apps/details?id=com.appdroid.develop.zielstk"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={androidLogoImage} alt="Скачать в Google Play" />
              </a>
              <a
                href="https://apps.apple.com/us/app/zielstk-studienkolleg/id1480404410"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={iosLogoImage} alt="Скачать в App Store" />
              </a>
            </div>
          </div>

          <div className="auth-phone-preview" aria-label="Экраны приложения ZielStk">
            <div className="auth-phone-preview__glow" />
            <AliceCarousel
              autoPlay
              autoPlayInterval={3200}
              animationDuration={650}
              disableButtonsControls
              disableDotsControls
              infinite
              items={screenshots.map((image, index) => (
                <img
                  key={image}
                  src={image}
                  className="auth-phone-preview__image"
                  alt={`Экран приложения ${index + 1}`}
                />
              ))}
            />
          </div>
        </section>

        <section className="auth-content-grid">
          <div className="auth-card">
            <span className="auth-eyebrow">Личный кабинет</span>
            <h2>Начни подготовку сейчас</h2>
            <p className="auth-card__intro">
              Войди через Яндекс или используй адрес электронной почты.
            </p>

            {yandexPasswordMode ? (
              <div className="yandex-password-panel">
                <div className="yandex-password-panel__heading">
                  <span className="yandex-auth-button__mark" aria-hidden="true">Я</span>
                  <div>
                    <h3>
                      {yandexPasswordMode === 'setup'
                        ? 'Создайте пароль ZielStk'
                        : 'Введите пароль ZielStk'}
                    </h3>
                    <p>
                      {yandexPasswordMode === 'setup'
                        ? 'Email получен из Яндекса. Придумайте пароль для сайта и мобильных приложений.'
                        : 'Яндекс подтвердил email. Для входа укажите пароль от вашего аккаунта ZielStk.'}
                    </p>
                  </div>
                </div>

                <form className="email-auth-form" onSubmit={onYandexPasswordSubmit}>
                  <label>
                    <span>Email из Яндекса</span>
                    <input type="email" value={yandexEmail} readOnly />
                  </label>
                  <label>
                    <span>Пароль ZielStk</span>
                    <input
                      type="password"
                      value={yandexPassword}
                      onChange={onYandexPasswordChange}
                      autoComplete={yandexPasswordMode === 'setup' ? 'new-password' : 'current-password'}
                      minLength="6"
                      maxLength="128"
                      placeholder="Не менее 6 символов"
                      required
                      autoFocus
                    />
                  </label>
                  {yandexPasswordMode === 'setup' && (
                    <label>
                      <span>Повторите пароль</span>
                      <input
                        type="password"
                        value={yandexPasswordConfirmation}
                        onChange={onYandexPasswordConfirmationChange}
                        autoComplete="new-password"
                        minLength="6"
                        maxLength="128"
                        placeholder="Введите пароль ещё раз"
                        required
                      />
                    </label>
                  )}
                  <button
                    type="submit"
                    className="email-auth-submit"
                    disabled={isYandexPasswordLoading}
                  >
                    {isYandexPasswordLoading
                      ? 'Подождите…'
                      : yandexPasswordMode === 'setup'
                        ? 'Сохранить пароль и войти'
                        : 'Войти'}
                  </button>
                </form>

                <div className="email-auth-actions">
                  <button type="button" onClick={onCancelYandexPassword}>
                    Другой способ входа
                  </button>
                  {yandexPasswordMode === 'signin' && (
                    <button type="button" onClick={onYandexPasswordReset}>
                      Забыли пароль?
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <>
                <button
                  type="button"
                  className="yandex-auth-button"
                  onClick={onYandexSignIn}
                  disabled={isYandexLoading}
                >
                  <span className="yandex-auth-button__mark" aria-hidden="true">Я</span>
                  <span>{isYandexLoading ? 'Переходим в Яндекс…' : 'Войти с Яндекс ID'}</span>
                </button>

                <div className="auth-divider"><span>или</span></div>

                <form className="email-auth-form" onSubmit={onEmailAuth}>
                  <label>
                    <span>Email</span>
                    <input
                      type="email"
                      value={email}
                      onChange={onEmailChange}
                      autoComplete="email"
                      placeholder="name@example.com"
                      required
                    />
                  </label>
                  <label>
                    <span>Пароль</span>
                    <input
                      type="password"
                      value={password}
                      onChange={onPasswordChange}
                      autoComplete={isRegistering ? 'new-password' : 'current-password'}
                      minLength="6"
                      placeholder="Не менее 6 символов"
                    required
                    />
                  </label>
                  <button
                    type="submit"
                    className="email-auth-submit"
                    disabled={isEmailAuthLoading}
                  >
                    {isEmailAuthLoading
                      ? 'Подождите…'
                      : isRegistering
                        ? 'Создать аккаунт'
                        : 'Войти по email'}
                  </button>
                </form>

                <div className="email-auth-actions">
                  <button type="button" onClick={onToggleEmailAuthMode}>
                    {isRegistering ? 'У меня уже есть аккаунт' : 'Создать аккаунт'}
                  </button>
                  {!isRegistering && (
                    <button type="button" onClick={onPasswordReset}>
                      Забыли пароль?
                    </button>
                  )}
                </div>
              </>
            )}

            {authError && <p className="auth-error" role="alert">{authError}</p>}
            {authNotice && <p className="auth-notice" role="status">{authNotice}</p>}

            <p className="email-auth-legal">
              Продолжая, вы принимаете{' '}
              <a
                href="https://firebasestorage.googleapis.com/v0/b/ziel-studienkolleg.appspot.com/o/Documents%2FNutzungsvertrag_der_Plattform.pdf?alt=media&token=9e68fe40-f9b0-4e4e-9935-6ee5e7b58102"
                target="_blank"
                rel="noopener noreferrer"
              >
                условия использования
              </a>{' '}
              и{' '}
              <a
                href="https://firebasestorage.googleapis.com/v0/b/ziel-studienkolleg.appspot.com/o/Documents%2FDatenschutzerkl_228_rung.pdf?alt=media&token=df5d15df-ac6c-4883-9396-4f497f6f864b"
                target="_blank"
                rel="noopener noreferrer"
              >
                политику конфиденциальности
              </a>.
            </p>

            <div className="google-account-note">
              <span className="google-account-note__icon" aria-hidden="true">G</span>
              <span>
                Есть аккаунт Google?{' '}
                <a href={germanSiteUrl} target="_blank" rel="noopener noreferrer">
                  Перейти на немецкую версию
                </a>
              </span>
            </div>
          </div>

          <div className="auth-stats" aria-label="Возможности ZielStk">
            <article>
              <strong>{totalNumber ?? '—'}</strong>
              <span>заданий по {themesNumber ?? '—'} темам</span>
            </article>
            <article>
              <strong>{examNumber ?? '—'}</strong>
              <span>заданий по материалам прошлых вступительных экзаменов</span>
            </article>
            <article>
              <strong>Гибко</strong>
              <span>плати только за те материалы, которые действительно нужны</span>
            </article>
          </div>
        </section>

        <section className="auth-benefit">
          <div>
            <span className="auth-eyebrow">Всегда под рукой</span>
            <h2>Учись в удобном темпе</h2>
            <p>
              Задания, темы и полезные материалы доступны в мобильном
              приложении.
            </p>
          </div>
          <img src={phoneStock} alt="Приложение ZielStk на смартфоне" />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ModernLanding;
